import { UntypedFormControl } from '@angular/forms';

export function MatchOtherValidator(otherControlName: string): any {
  let thisControl: UntypedFormControl;
  let otherControl: UntypedFormControl;

  return function matchOtherValidate(control: UntypedFormControl): any {
    if (!control.parent) {
      return undefined;
    }

    // Initializing the validator.
    if (!thisControl) {
      thisControl = control;
      otherControl = control.parent.get(otherControlName) as UntypedFormControl;
      if (!otherControl) {
        throw new Error('matchOtherValidator(): other control is not found in parent group');
      }
      otherControl.valueChanges.subscribe(() => thisControl.updateValueAndValidity());
    }

    if (!otherControl) {
      return undefined;
    }

    if (otherControl.value !== thisControl.value) {
      return {
        matchOther: true,
      };
    }

    return undefined;
  };
}
